import { axiosInstance } from "network/apis";

export const getInterviewsListForPM = async (payload) => {
  let filteredClientsList = "";
  if (payload.filteredClients && payload.filteredClients.length === 0)
    filteredClientsList = "('')";
  else
    filteredClientsList = `(${payload.filteredClients
      .map((c) => `'${c}'`)
      .join(",")})`;
  let filteredProjects = "";
  let offset = payload.offset;
  let activeTab = payload.activeTab;
  let handleScroll = payload.handleScroll;
  let paymentStatusCode = payload.paymentStatusCode;
  if (payload.filteredItems && payload.filteredItems.length === 0)
    filteredProjects = "('')";
  else
    filteredProjects = `(${payload.filteredItems
      .map((c) => `'${c}'`)
      .join(",")})`;
  return await axiosInstance.post(
    `/projects/${payload.clientId}/interviews${
      payload.q ? `?q=${payload.q}` : ""
    }`,
    {
      externalClientsIds: filteredClientsList,
      projectsIds: filteredProjects,
      offset: offset,
      activeTab: activeTab,
      handleScroll: handleScroll,
      paymentStatusCode,
    },
    { handlerEnabled: true }
  );
};

export const getInterviewsListForMod = async (payload) => {
  let filteredProjects = "";
  let paymentStatusCode = payload.paymentStatusCode;
  if (payload.filteredItems && payload.filteredItems.length === 0)
    filteredProjects = "('')";
  else
    filteredProjects = `(${payload.filteredItems
      .map((c) => `'${c}'`)
      .join(",")})`;
  return await axiosInstance.post(
    `/moderator/get-all-interviews/${payload.moderatorId}${
      payload.q ? `?q=${payload.q}` : ""
    }`,
    { projectsIds: filteredProjects, paymentStatusCode },
    { handlerEnabled: true }
  );
};

export const invalidateInterview = async (body) => {
  return await axiosInstance.post(`/interview/invalidate`, body, {
    handlerEnabled: true,
  });
};

export default {
  getInterviewsListForPM,
  getInterviewsListForMod,
  invalidateInterview,
};
